import React, { useMemo } from "react";
import PropTypes from "prop-types";

import { TextField } from "@material-ui/core";

import Dropdown from "components/Dropdown";

function PermissionDropdown({
  value,
  roleData,
  disabled,
  onChangeCb,
  ...restProps
}) {
  const roleOptions = useMemo(() => {
    return roleData.map(({ id, title }) => {
      return {
        key: id,
        value: id,
        text: title,
      };
    });
  }, [roleData]);

  const dropdownValue = useMemo(() => {
    if (!value || !roleOptions.length) {
      return {
        key: "",
        value: "",
        text: "",
      };
    }
    return roleOptions.find((o) => {
      return o.value === value;
    });
  }, [value, roleOptions]);

  return (
    <Dropdown
      {...restProps}
      disableClearable
      blurOnSelect
      size="small"
      disabled={disabled}
      options={roleOptions}
      getOptionSelected={(option) => {
        return option.value === value;
      }}
      getOptionLabel={(option) => {
        return option.text;
      }}
      value={dropdownValue}
      onChange={(_, newValue) => {
        onChangeCb(newValue.value);
      }}
      renderInput={(params) => {
        return (
          <TextField
            {...params}
            inputProps={{
              ...params.inputProps,
              style: { fontSize: ".8rem" },
            }}
            fullWidth
            variant="outlined"
          />
        );
      }}
    />
  );
}

PermissionDropdown.propTypes = {
  value: PropTypes.string,
  roleData: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
    })
  ),
  disabled: PropTypes.bool,
  onChangeCb: PropTypes.func,
};

PermissionDropdown.defaultProps = {
  value: null,
  roleData: [],
  disabled: false,
  onChangeCb: () => {},
};

export default PermissionDropdown;
